const toCodepoints = (emoji: string, stripVariationSelector: boolean): string =>
  Array.from(emoji)
    .map((ch) => ch.codePointAt(0)!.toString(16))
    .filter((cp) => !(stripVariationSelector && cp === "fe0f"))
    .join("-");

const BASE =
  "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@15.1.2/img/apple/64";

// Some emoji (heart, etc.) only resolve with the FE0F variation selector
// kept in the filename; most resolve without it. Rather than maintain an
// exception list, try the fully-qualified form first and fall back.
export const appleEmojiUrls = (emoji: string) => ({
  primary: `${BASE}/${toCodepoints(emoji, false)}.png`,
  fallback: `${BASE}/${toCodepoints(emoji, true)}.png`,
});
